/**
 * Componente adaptador para manejar eventos de line-items en un modal
 * Reutiliza la lógica de cart-drawer pero sin duplicar toda su funcionalidad
 */
class LineItemsHandler extends HTMLElement {
  constructor() {
    super();

    this.boundUpdateLineItems = this.updateLineItems.bind(this);
  }

  connectedCallback() {
    this.productUrl = this.dataset.productUrl;
    this.addEventListener('pb:quantity:updated', this.boundUpdateLineItems);
  }


  disconnectedCallback() {
    // Eliminar el listener usando la misma referencia
    this.removeEventListener('pb:quantity:updated', this.boundUpdateLineItems);
  }


  /**
   * Procesa eventos de actualización de cantidad y envía cambios al carrito
   */
  async updateLineItems(event) {
    const { quantity, variantId, lineIndex, productTitle, message } = event.detail;

    try {
      this.lockButtons();

      const body = JSON.stringify({
        line: lineIndex,
        quantity: quantity
      });
      
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body
      });
      
      if (!response.ok) {
        throw new Error(`error cart: ${response.status}`);
      }
      
      window.showToast(`${message}: ${productTitle}`);

    } catch (error) {
      this.unlockButtons();
      console.error(`Error at line ${lineIndex} from cart:`, error);
      window.showToast(`${window.globalTranslations.errorAddToCart}: ${productTitle}`, 'error');
    } finally {
      this.updateCart(variantId);
    }
  }

  /**
   * Deshabilita botones durante operaciones de carrito
   */
  lockButtons() {
    const form = this.querySelector('form');
    if (form) form.classList.add('in-request');
    
    this.querySelectorAll('button').forEach(button => {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
    });
  }

  /**
   * Rehabilita botones después de errores
   */
  unlockButtons() {
    const form = this.querySelector('form');
    if (form) form.classList.remove('in-request');
    
    this.querySelectorAll('button').forEach(button => {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
    });
  }

  /**
   * Notifica cambios en el carrito y recarga contenido del modal
   */
  updateCart(variantId = null) {
    console.log('CART:REFRESH 13')
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: {
        variantId
      }
    }));

    this.loadModalContent();
  }

  /**
   * Carga contenido actualizado del modal desde la API de secciones
   */
  loadModalContent() {
    const baseUrl = this.productUrl;
    const url = new URL(baseUrl, window.location.href);
    
    // Preservar parámetros de consulta existentes
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach((value, key) => {
      if (!url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    });
    
    url.searchParams.set('section_id', 'line-items');
    
    fetch(url.toString())
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        this.handleLineItemsResponse(html);
      })
      .catch(error => {
        console.error('Error loading modal content:', error);
      });
  }

  /**
   * Procesa la respuesta HTML y actualiza el modal
   * @param {string} html - Contenido HTML de la respuesta
   */
  handleLineItemsResponse(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const lineItems = doc.querySelector('#line-items-modal');
    
    if (!lineItems) {
      console.warn('No se encontró el contenido de line items en la respuesta');
      return;
    }
    
    const modal = document.querySelector('#modal-cards');
    if (!modal) {
      console.error('No se encontró el modal en el DOM');
      return;
    }
    
    // Actualizar contenido y mostrar sección correspondiente
    const contentContainer = modal.querySelector('#content-line-items');
    if (contentContainer) contentContainer.innerHTML = lineItems.innerHTML;
    
    modal.querySelector('#content-main-product')?.classList.add('hidden');
    modal.querySelector('#content-line-items')?.classList.remove('hidden');
    
    modal.show(this.querySelector('button'));
  }
}

customElements.define('line-items-handler', LineItemsHandler);